import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UiSkeletonCustomMeasurements } from "@webapp/ui/skeleton/skeleton.type";

@Component({
  selector: "update-metric-skeleton",
  templateUrl: "./update-metric-skeleton.component.html",
  styleUrls: ["./update-metric-skeleton.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateMetricSkeletonComponent {
  public formItems: UiSkeletonCustomMeasurements[] = [
    {
      width: "100%",
      height: "16px",
      margin: "0",
    },
    {
      width: "271px",
      height: "24px",
      margin: "0",
    },
    {
      width: "100%",
      height: "76px",
      margin: "0",
    },
    {
      width: "100%",
      height: "66px",
      margin: "0",
    },
    {
      width: "100%",
      height: "16px",
      margin: "0",
    },
    {
      width: "100%",
      height: "16px",
      margin: "0",
    },
    {
      width: "100%",
      height: "16px",
      margin: "0",
    },
    {
      width: "100%",
      height: "16px",
      margin: "0",
    },
  ];
}
